import { kea } from 'kea'
import PropTypes from 'prop-types'

import rootLogic from '~/scenes/logic'
import { selector as configSelector } from '~/config'

export const buttons = 'buttons';
export const text = 'text';

export default kea({
  key: (props) => {
    const {id, gfyPlugin} = props;

    return `${gfyPlugin}-${id}`
  },

  connect: {
    actions: [
      rootLogic, [
        'auth0Authenticated',
        'logout'
      ]
    ],
    values: [
      rootLogic, [
        'loggedIn',
        'userInfo',
        'auth0Settings',
      ]
    ],
  },

  path: (key) => {
    return ['plugins', 'auth', key];
  },

  constants: () => [
    buttons,
    text
  ],
  selectors : ({ constants, selectors }) => ({
    config: [
      () => [
        configSelector
      ], (config) => {
        return config
      },
      PropTypes.object
    ]
  })

})
